import { Button, Checkbox, Form, Input, Row } from "antd";
import { InstitutionEmail } from "../../redux/reducer/institution";
import { useState } from "react";
import Editor from "../molecules/Editor";
import { defaultEmailJsonContentTiptap } from "../../utils";
import { RootState } from "../../configureStore";
import { useSelector } from "react-redux";

interface EmailConfigurationFormParams {
    institutionEmail: InstitutionEmail;
    onFinish: (email: Partial<InstitutionEmail>) => void;
}

const EmailConfigurationForm = ({
    institutionEmail,
    onFinish,
}: EmailConfigurationFormParams) => {
    const loading = useSelector<RootState, boolean>(({ status: { loading: l } }) => l['institution/PATCH_INSTITUTION'])

    const [form] = Form.useForm<InstitutionEmail>();
    const [useWL, setUseWL] = useState<boolean>(false);
    const [editing, setEditing] = useState<boolean>(false);

    return (
        <Form
            form={form}
            initialValues={institutionEmail}
            onFinish={onFinish}
        >
            <Form.Item
                name={["emailWhiteLabel", "enabled"]}
                valuePropName="checked"
                getValueFromEvent={(e) => {
                    setUseWL(e.target.checked);
                    return e.target.checked;
                }}
            >
                <Checkbox>
                    White-label Invitation Email
                </Checkbox>
            </Form.Item>
            <Form.Item
                name={["emailWhiteLabel", "subject"]}
                label="Email Subject"
                style={{ width: '75%' }}
            >
                <Input disabled={!useWL} placeholder="Enter Email Subject" />
            </Form.Item>
            <Form.Item
                name={["emailWhiteLabel", "content"]}
                label="Content"
            >
                <Editor
                    disabled={!useWL}
                    content={form.getFieldValue(["emailWhiteLabel", "content", "json"]) || defaultEmailJsonContentTiptap}
                    editingChange={(isEdit) => { setEditing(isEdit); }}
                    onSave={async (jsonContent, htmlContent) => {
                        form.setFieldsValue({
                            emailWhiteLabel: {
                                content: {
                                    json: jsonContent,
                                    html: htmlContent ?? '',
                                }
                            }
                        });
                    }}
                    title={""}
                    type="email"
                    loading
                />
            </Form.Item>
            <Row align='middle' justify='end'>
                <Button loading={loading} disabled={editing} type="primary" htmlType="submit">
                    Submit
                </Button>
            </Row>
        </Form>
    );
};

export default EmailConfigurationForm;
